<form [formGroup]="contactForm">
<div class="bg-white rounded-lg py-3 mb-6">
    <div class="flex justify-between items-center mt-3 mb-6 px-6">
      <h1 class="font-semibold">Contact Details</h1>
      <button class="bg-[#D9D9D9] rounded-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_1958_7961)">
            <path
              d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
              fill="#6C757D"
            />
          </g>
          <defs>
            <clipPath id="clip0_1958_7961">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
    <div class="grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">Mobile</h1>
        <input
          type="number"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter mobile number"
          formControlName="mobile"
        />
      </div>

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">Address</h1>
        <input
          type="text"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter the address"
          formControlName="address"
        />
      </div>

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">Telephone No</h1>
        <input
          type="number"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter the telephone number"
          formControlName="telephoneNo"
        />
      </div>

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">State</h1>
        <input
          type="text"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter the state"
          formControlName="state"
        />
      </div>

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">City</h1>
        <input
          type="text"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter the city"
          formControlName="city"
        />
      </div>

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">Postal code</h1>
        <input
          type="number"
          (keypress)="keyPressNumbers($event)"
          maxlength="6"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter the postal code"
          formControlName="postalCode"
        />
      </div>

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">Country</h1>
        <select
          class="text-[#6C757D] w-full border p-2 rounded-md outline-none"
          formControlName="country"
        >
          <option>Enter your country</option>
          <option>India</option>
        </select>
      </div>
    </div>
</div>

<div class="bg-white rounded-lg py-3 px-12 flex justify-end gap-4">
  <button class="bg-[#0000000a] rounded-lg py-2 px-4">Save</button>
  <!-- <button class="bg-[#0058e9] rounded-lg py-2 px-4 text-white">Draft</button> -->
</div>
</form>

